import * as React from 'react';
import { Minus, Square, X } from 'lucide-react';
import { electronService } from '@/services/electronService';

const TitleBar: React.FC = () => {
  // Only render if running in Electron
  if (!electronService.isElectron()) {
    return null;
  }

  return (
    <div 
      className="flex justify-between items-center bg-[#1e2124] text-white h-8 w-full z-[9999] fixed top-0 left-0"
      style={{ WebkitAppRegion: 'drag' } as React.CSSProperties}
    >
      <div className="flex items-center pl-3 h-full">
        <img 
          src="/sell-logo.ico" 
          alt="Logo" 
          className="h-4 w-4 mr-2"
          style={{ WebkitAppRegion: 'no-drag' } as React.CSSProperties}
        />
        <span className="text-xs font-semibold tracking-wide text-gray-200">|Sell| (Modulus Sell)</span>
      </div>

      <div className="flex h-full" style={{ WebkitAppRegion: 'no-drag' } as React.CSSProperties}>
        <button
          className="h-full px-4 hover:bg-gray-700 transition-colors flex items-center justify-center outline-none cursor-default"
          onClick={() => electronService.minimizeWindow()}
          title="Minimize"
        >
          <Minus size={14} className="text-gray-300" />
        </button>
        <button
          className="h-full px-4 hover:bg-gray-700 transition-colors flex items-center justify-center outline-none cursor-default"
          onClick={() => electronService.maximizeWindow()}
          title="Maximize"
        >
          <Square size={12} className="text-gray-300" />
        </button>
        <button
          className="h-full px-4 hover:bg-red-600 transition-colors flex items-center justify-center outline-none cursor-default"
          onClick={() => electronService.closeWindow()}
          title="Close"
        >
          <X size={16} className="text-gray-300" />
        </button>
      </div>
    </div>
  );
};

export default TitleBar;
